/**
 * Payment Method
 *
 * Payment methods used in the application.
 */
export const PaymentMethod = {
  BANK_TRANSFER: 'BANK_TRANSFER', // Bankovní převod
  CASH: 'CASH', // Hotovost
  CARD: 'CARD', // Platební karta
  CHECK: 'CHECK', // Šek
  DIRECT_DEBIT: 'DIRECT_DEBIT', // Přímé inkaso
  CLEARING: 'CLEARING', // Zápočet
  OTHER: 'OTHER' // Jiná forma platby
} as const;

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];
